import axios from '../axios/axios-auth'

export default class MapOverlayService {

    getMapOverlay(params, vehiclesIds) {
        return axios.post(`/events/v1/eventsDailySummary/today/mapOverlay`, vehiclesIds, { params }).then(response => response.data)
    }

    getEventsDailySummary(params, startDate, endDate) {
        return axios.get(`/events/v1/eventsDailySummary/vehicles/date/${startDate}/${endDate}`, { params }).then(response => response.data)
    }

    getVehiclesInMaintenanceField(organizationId, request) {
        return axios.post(`/api/v3/realTimeLme/maintenance/${organizationId}`, request).then(response => response.data)
    }

}
